<template>
  <div id="Footer">
    <div class="footer">
      <div class="many">
        <div class="many_left">
          <div>
            <h5>售后服务</h5>
            <ul>
              <li>
                <a href="/help.html#/doc/88954e00-91de-4e1d-9a11-c7ccd47bfe18" target="_blank">售后政策</a>
              </li>
              <!-- <li>
                <a href="/help.html#/doc/cec13651-6b00-44d1-8ded-a98cc61ed3e0" target="_blank">维修与技术支持</a>
              </li> -->
            </ul>
          </div>
          <div>
            <h5>购物相关</h5>
            <ul>
              <li>
                <a href="/help.html#/doc/057c308b-dfb0-4e62-8c34-ed95d45575aa" target="_blank">服务协议</a>
              </li>
              <li>
                <a href="/help.html#/list" target="_blank">常见问题</a>
              </li>
            </ul>
          </div>
          <div>
            <h5>关于我们</h5>
            <ul>
              <li>
                <a href="/help.html#/doc/e5289a06-9791-4afb-a323-9346fde204e2" target="_blank">公司简介</a>
              </li>
              <li>
                <a href="/help.html#/doc/ed7da2f5-78f7-418f-b697-f08e7a81417c" target="_blank">商城简介</a>
              </li>
              <li>
                <a href="/help.html#/doc/ee7ddc6c-9765-4814-96f1-a6f7681b54df" target="_blank">意见反馈</a>
              </li>
              <li>
                <a href="/help.html#/doc/f309503d-892d-4c71-ab01-c403c75c7be8" target="_blank">诚征英才</a>
              </li>
            </ul>
          </div>
          <div/>
        </div>
        <div class="many_right">
          <!-- // href="https://www.tidio.com/talk/zg9hsnwuegzcqghkhyatknkmnjgcmieh"
            target="_blank" -->
          <a
            style="text-decoration:none;"
            @click.stop="openServer"
          >
            <div>
              <img src="~@/assets/images/icon_p.png" alt>
              <span>在线客服</span>
            </div>
          </a>
          <!-- <div class="z-mall">
            <div class="attention">
              <img src="~@/assets/images/mall_minicode.jpg" alt="微信小程序">
              <span>小程序</span>
            </div>
            <div class="attention">
              <img src="~@/assets/images/mall_qrcode.jpg" alt="微信公众号">
              <span>公众号</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="foot_bottom">
        <div class="foot_bottom_1">
          <img src="~@/assets/images/malldomin.png" alt>
        </div>
        <div class="foot_bottom_2">
          <ul>
            <li>
              <a href="/help.html#/doc/e5289a06-9791-4afb-a323-9346fde204e2" class="scolor" target="_blank">公司简介</a>丨
            </li>
            <li>
              <a href="/help.html#/doc/f3372003-8fd7-4e0c-aff2-ed04d8830d6a" class="scolor" target="_blank">联系方式</a>丨
            </li>
            <li>
              <a href="/help.html#/doc/057c308b-dfb0-4e62-8c34-ed95d45575aa" class="scolor" target="_blank">服务协议</a>丨
            </li>
            <li>
              <a href="/help.html#/doc/2fe3b6f4-d315-43f6-8aea-14ea0cfcafac" class="scolor" target="_blank">隐私声明</a>丨
            </li>
            <!-- <li>
              <a href="/resource/images/design/163531906043326560.jpg" class="scolor" target="_blank">营业执照</a>丨
            </li> -->
            <li>
              <a href="/help.html#/notice/list" class="scolor" target="_blank">商城公告</a>
            </li>
          </ul>
        </div>
        <div class="foot_bottom_3">
          <p>版权所有：上海斑马打印科技有限公司 &nbsp;&nbsp;
            <a href="https://beian.miit.gov.cn" target="_blank">沪ICP备11049007号-4</a> &nbsp;&nbsp;
            <!-- <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11030102010567" target="_blank"><img src="~@/assets/images/公安备案图标.png">京公网安备 11030102010567号</a> -->
          </p>
          <p>
            技术支持：<a>诚信建站</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Footer',
  components: {},
  methods: {
    openServer() {
      window.open('https://www.tidio.com/talk/zg9hsnwuegzcqghkhyatknkmnjgcmieh',
        '在线客服',
        'height=750, width=750, top=0, left=2, toolbar=no, menubar=no, scrollbars=no, resizable=yes,location=no, status=no'
      )
    }
  }
}
</script>

<style lang="scss" scoped>
#Footer {
  width: 100%;
  height: 281px;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-top: #e5e5e5 1px solid;
  & > .footer {
    width: 1200px;
    height: 281px;
    margin: 0 auto;
    & > .footer_five {
      width: 1200px;
      height: 82px;
      border-bottom: #e5e5e5 1px solid;
      & > .footer_five_1 {
        width: auto;
        height: 40px;
        margin: 21px 0 0 0;
        float: left;
        & > div {
          width: 40px;
          height: 40px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 15px;
          background: url(~@/assets/images/icon01.svg?20170620) no-repeat;
          background-position: -74px 0;
        }
        & > a {
          text-decoration: none;
          color: #3a3a3a;
        }
      }
      & > .footer_five_2 {
        width: auto;
        height: 40px;
        margin: 21px 0 0 120px;
        float: left;
        & > div {
          width: 40px;
          height: 40px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 15px;
          background: url(~@/assets/images/icon01.svg?20170620) no-repeat;
          background-position: -154px 0;
        }
        & > a {
          text-decoration: none;
          color: #3a3a3a;
        }
      }
      & > .footer_five_3 {
        width: auto;
        height: 40px;
        margin: 21px 0 0 120px;
        float: left;
        & > div {
          width: 40px;
          height: 40px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 15px;
          background: url(~@/assets/images/icon01.svg?20170620) no-repeat;
          background-position: -194px 0;
        }
        & > a {
          text-decoration: none;
          color: #3a3a3a;
        }
      }
      & > .footer_five_4 {
        width: auto;
        height: 40px;
        margin: 21px 0 0 120px;
        float: left;
        & > div {
          width: 40px;
          height: 40px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 15px;
          background: url(~@/assets/images/icon01.svg?20170620) no-repeat;
          background-position: -114px 0;
        }
        & > a {
          text-decoration: none;
          color: #3a3a3a;
        }
      }
    }
    & > .many {
      width: 1200px;
      height: 220px;
      & > .many_left {
        width: 920px;
        height: 170px;
        float: left;
        border-right: #e5e5e5 1px solid;
        margin-top: 25px;
        & > div {
          float: left;
          width: 120px;
          height: auto;
          margin-right: 60px;
          & > ul {
            & > li {
              list-style: none;
              & > a {
                color: #666;
                font-size: 12px;
                text-decoration: none;
                line-height: 24px;
              }
              & > a:hover {
                color: red;
              }
            }
          }
          & > h5 {
            color: #333333;
            font-size: 14px;
            line-height: 30px;
          }
        }
      }
      & > .many_right {
        width: 279px;
        height: 170px;
        float: left;
        margin-top: 25px;
        text-align: center;
        & > h4 {
          font-size: 24px;
          color: #575757;
        }
        & > p {
          font-size: 14px;
          margin-top: 6px;
          color: #666;
        }
        & > a {
          width: 170px;
          height: 34px;
          display: block;
          background-color: #333;
          border-radius: 15px;
          margin: 0 auto;
          & > div {
            margin: 0 auto;
            & > img {
              width: 26px;
              height: 26px;
              display: block;
              float: left;
              margin: 4px 0 0 37.5px;
            }
            & > span {
              text-align: center;
              font-size: 16px;
              color: #fff;
              display: block;
              float: left;
              margin: 6px 0 0 5px;
            }
          }
        }
        & > a:hover {
          background-color: #777777;
        }
        & > .z-mall {
          width: 260px;
          height: 110px;
          margin: 10px auto 0;
          text-align: center;
          & > .attention{
            display: inline-block;
            width: 110px;
            height: 130px;
            text-align: center;
            & > img{
              width: 100px;
            }
            & > span{
              display: block;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
              color: #666;
            }
          }
          & > span {
            display: block;
            float: left;
            width: auto;
            height: 36px;
            color: #303030;
            line-height: 2;
            margin: 0 10px 0 20px;
          }
          & > img {
            display: block;
            float: left;
            width: 30px;
            height: 30px;
            margin-right: 7px;
          }
          & > img:hover {
            opacity: 0.6;
          }
        }
      }
    }
    & > .foot_bottom {
      width: 1200px;
      height: 60px;
      margin: 0 auto;
      border-top: #e5e5e5 1px solid;
      & > .foot_bottom_1 {
        width: 130px;
        height: auto;
        float: left;
        margin-top: 20px;
        & > img {
          width: 130px;
          height: auto;
        }
      }
      & > .foot_bottom_2 {
        width: 400px;
        height: auto;
        float: left;
        margin: 20px 0 0 20px;
        & > ul {
          width: 750px;
          height: 16px;
          margin: 5px auto;
          & > li {
            list-style: none;
            float: left;
            font-size: 12px;
            color: #a4abc1;
            & > a {
              text-decoration: none;
              color: #a4abc1;
            }
            & > a:hover {
              color: red;
            }
            & > .scolor {
              color: #777777;
            }
          }
        }
      }
      & > .foot_bottom_3 {
        float: right;
        width: auto;
        height: auto;
        margin: 10px 0 0 0;
        font-size: 12px;
        color: #777;
        & > p{
          line-height:20px;
          text-align:right;
          & > a {
            color: #777;
            & > img{
              line-height: 20px;
              height:20px;
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/foot.vue